import assetTypeService from "../../../../services/assetService/assetTypeService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETTYPES } from "../../../../utils/constants";
import { AssetTypeInterface } from "../../../../models/AssetModel/AssetType";

const useAssetTypes = (page: number, pageSize: number) =>
  useQuery<AssetTypeInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETTYPES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetTypeService.GetAll(page, pageSize),
    initialData: [],
  });

export default useAssetTypes;
